export default __webpack_public_path__ + "static/media/icon-cancel-light.74aa3e60.svg";